import Header from "components/Header";
import imgBg from "img/bg_2.png";
import imgGiftFront from "img/gift_1.png";
import imgGiftBack from "img/gift_2.png";
import imgLetter from "img/letter-bg.png";
import mailSent from "img/mail.png";

const SentPage = () => {
  return (
    <section className="main booking">
      <div class="main-bg">
        <img src={imgBg} alt="#" />
      </div>

      <div className="main-gift-front">
        <img src={imgGiftFront} alt="#" />
      </div>

      <div className="main-gift-back">
        <img src={imgGiftBack} alt="#" />
      </div>

      <div className="letter">
        <div className="letter-wrapper">
          <img src={imgLetter} alt="Письмо Деду Морозу" />
        </div>
        <div className="bottom  bottom--ready">
          <div className="mail-sent">
            <img src={mailSent} alt="Письмо Деду Морозу" />
          </div>

          <p className="bottom__txt">
            Ваше письмо <br />
            успешно отправлено! <br />
          </p>
        </div>
      </div>
    </section>
  );
};

export default SentPage;
